// import React, { useState } from 'react'
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import {toast} from "react-toastify"


// const initialUser = {password:"", identifier:""};

// const Login = () => {
//   const navigate = useNavigate();
//     const [user, setUser] = useState(initialUser)

//     const handleChange = ({target}) => {
//         const {name, value} = target
//         setUser((currentUser) => ({
//             ...currentUser,
//             [name] : value,
//         }))
//     }

//     const handleLogin = async () => {
//         const url = `http://localhost:1337/api/auth/local`
//         try{
//             if(user.identifier && user.password) {
//                 const {data} = await axios.post(url, user)
//                 if(data.jwt){
//                   setUser(initialUser);
//                   navigate("/")
//                 }
//                 // console.log({res});
//             }
//         }catch(error){
//             console.log(error);
//             toast.error(error.message, {
//                 hideProgressBar:true,
//             })
//         }
//     }


//   return (
//     <div>
//       <form>
//         <input type="email" name='identifier' value={user.identifier} onChange={handleChange} placeholder='Enter your Email' />
//         <input type="password" name='password' value={user.password} onChange={handleChange} placeholder='Enter Password' />
//         <button onClick={handleLogin}>Login</button>
//         <h6>Click <Link to="/registeration">Here</Link> to signup</h6>

//       </form>
//     </div>
//   )
// }

// export default Login
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { storeUser } from '../../helpers';

const API_URL = 'http://localhost:1337';

const Login = () => {
  const history = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`http://localhost:1337/api/auth/local`, {
        identifier: formData.email,
        password: formData.password,
      });
      console.log('Login successful:', response.data);
      storeUser(response.data)
      toast.success("Logged in successfully")
      // Handle successful login, e.g., store authentication token in local storage
      history('/'); // Redirect to login page after successful registration
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} />
        <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};
export default Login;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Home from '../Home/Home';
// import { toast } from 'react-toastify';

// function Navbar({ isLoggedIn, handleLogout }) {
//   return (
//     <nav>
//       <ul style={{position:"relative"}}>
//         {isLoggedIn && <li><button onClick={handleLogout} style={{position: "absolute",backgroundColor:"black", width:"100%",color:"white" }}>Logout</button></li>}
//       </ul>
//     </nav>
//   );
// }

// function Login() {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');

//   // Function to handle login
//   const handleLogin = async () => {
//     try {
//       const response = await axios.post(`http://localhost:1337/api/auth/local`, {
//         identifier: username,
//         password: password,
//       });
//       // Store the JWT token in local storage
//       localStorage.setItem('jwt', response.data.jwt);
//       setIsLoggedIn(true);
//       toast.success("Login Successfully")
//     } catch (error) {
//       console.error('Login failed:', error);
//       toast.error(error.message, {
//                          toastProgressBar: true,
//            })
//     }
//   };

 

//   // Check if user is logged in on component mount
//   useEffect(() => {
//     const jwt = localStorage.getItem('jwt');
//     if (jwt) {
//       setIsLoggedIn(true);
//     }
//   }, []);

//   return (
//     <div>
//       <Navbar isLoggedIn={isLoggedIn} handleLogout={handleLogout} />
//       <div>
//         {!isLoggedIn ? (
//           <div>
//             <input
//               type="text"
//               placeholder="Username"
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//             />
//             <input
//               type="password"
//               placeholder="Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//             />
//             <button onClick={handleLogin}>Login</button>
//           </div>
//         ) : (
//           <>
//           <Home />
//           </>
         
//         )}
//       </div>
//     </div>
//   );
// }

// export default Login;
